import { AlertType, AlertTypeSchema } from '@/entities/alert-type';

export function alertTypeMapper(data?: string): AlertType | undefined {
  const result = AlertTypeSchema.safeParse(data);
  return result.success ? result.data : undefined;
}
